import gql from 'graphql-tag'

export const ObjectivesFragment = gql`
  fragment ObjectivesFragment on Objectives {
    fruit_and_vegetable
    complete_carbohydrate
    dried_vegetable
    meat
    fish
    sugary_product
  }
`
